module.exports = __webpack_public_path__ + "img/elliottMatsuura.ce4a8813.webp";